<template>
  <div class="sbMain">
    <div
      class="sbMain-head--title black--text font-weight-medium"
      :class="{ 'fs-18': breakpointXs, 'fs-25': !breakpointXs }"
    >
      <DashboardBreadcrumb :items="breadCrumbItems" />
    </div>
    <div class="sbMain-body mt-4">
      <v-card elevation="4" class="px-8 py-6">
        <v-row
          class="loader fill-height py-6"
          align="center"
          justify="center"
          v-if="isSbMainFormLoading || retrievingEditExportJob"
        >
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </v-row>
        <div v-else>
          <div class="sbMain-body--title fw-600" :class="{ 'fs-18': breakpointXs, 'fs-25': !breakpointXs }">
            Shipping Bill Main Details
          </div>
          <div class="sbMain-body--form pt-3">
            <ValidationObserver v-slot="{ passes }">
              <v-row>
                <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
                  <TextField
                    v-model="jobName"
                    rules="required|max:6"
                    :loading="isSbMainFormLoading || savingExportJob"
                    label="Job Name"
                    prefix="EXP/"
                    suffix="/2020-21"
                    type="number"
                    showIcons
                    :showOnlyErrorIcons="true"
                  />
                </v-col>
                <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
                  <DateField
                    :loading="isSbMainFormLoading || savingExportJob"
                    :inputLabel="'Job Date'"
                    v-model="jobDate"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
                  <TextField
                    v-model="cha"
                    :loading="isSbMainFormLoading || savingExportJob"
                    readonly
                    rules="required|max:30"
                    showIcons
                    :showOnlyErrorIcons="true"
                    label="CHA License Number"
                  />
                </v-col>
                <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
                  <TextField
                    v-model="icegateId"
                    :loading="isSbMainFormLoading || savingExportJob"
                    rules="required|max:15"
                    showIcons
                    readonly
                    :showOnlyErrorIcons="true"
                    label="ICEGATE ID"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
                  <AutoComplete
                    v-model="portLocationDropdownValue"
                    :loading="isSbMainFormLoading || savingExportJob"
                    rules="required"
                    showIcons
                    :items="portLocations"
                    item-text="text"
                    item-value="textIdentifier"
                    :return-object="true"
                    :showOnlyErrorIcons="true"
                    label="Port Location"
                    ref="portLocation"
                  />
                </v-col>
                <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
                  <AutoComplete
                    :return-object="true"
                    v-model="transportModeArray"
                    :loading="isSbMainFormLoading || savingExportJob"
                    rules="required"
                    :items="transportModes"
                    showIcons
                    item-text="text"
                    :showOnlyErrorIcons="true"
                    label="Transport Mode"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" :xs="12" :sm="6" :md="6">
                  <TextField
                    showIcons
                    :showOnlyErrorIcons="true"
                    v-model="rbiWaiverNo"
                    :loading="isSbMainFormLoading || savingExportJob"
                    label="RBI Waiver No"
                  />
                </v-col>
                <v-col cols="12" :xs="12" :sm="6" :md="6">
                  <DateField
                    rules="required"
                    v-model="rbiWaiverDate"
                    :loading="isSbMainFormLoading || savingExportJob"
                    :inputLabel="'RBI Waiver Date'"
                  />
                </v-col>
              </v-row>
              <div class="d-sm-flex justify-end" :class="{ 'text-center': breakpointXs }">
                <v-btn
                  width="140"
                  color="indigo"
                  large
                  class="white--text my-3 mr-2"
                  :loading="isSbMainFormLoading || savingExportJob"
                  @click="copyExportJob"
                >
                  <span class="font-weight-bold fs-15">Copy</span>
                  <v-icon class="font-weight-bold fs-15 ml-2">fa fa-copy</v-icon>
                </v-btn>
                <v-btn
                  width="140"
                  color="button-primary"
                  large
                  class="white--text my-3 mr-2"
                  :loading="isSbMainFormLoading || savingExportJob"
                  @click="passes(saveExportJob)"
                >
                  <span class="font-weight-bold fs-15">Save</span>
                </v-btn>
                <v-btn
                  width="140"
                  color="info"
                  large
                  class="white--text my-3"
                  :loading="isSbMainFormLoading || savingExportJob"
                  @click="$router.push({ name: 'dashboard.export.exporter' })"
                >
                  <span class="font-weight-bold fs-15">Next</span>
                  <v-icon class="font-weight-bold fs-15 ml-2">fa fa-arrow-circle-right</v-icon>
                </v-btn>
              </div>
            </ValidationObserver>
          </div>
        </div>
      </v-card>
    </div>
    <CopyExportJobModal v-if="copyExportJobModal" @close-export-job-modal="copyExportJobModal = false" />
  </div>
</template>
<script>
import CopyExportJobModal from "@/modules/DashboardModule/modules/ImportExportModule/modules/ExportModule/components/CopyExportJobModal";
import DashboardBreadcrumb from "@/modules/DashboardModule/components/DashboardBreadcrumb";
import { ValidationObserver } from "vee-validate";
import TextField from "@/components/TextField";
import DateField from "@/components/DateField";
import AutoComplete from "@/components/AutoComplete";
import { GET_ACCOUNT_DETAILS } from "@/modules/DashboardModule/store/actionTypes";
import * as MT from "@/modules/DashboardModule/modules/ImportExportModule/modules/ExportModule/store/mutationTypes";
import handleExportJobMixin from "@/modules/DashboardModule/modules/ImportExportModule/mixins/handleExportJobMixin";
import commonMethodsMixin from "@/modules/commonMethodsMixin";
export default {
  name: "SBMain",
  components: {
    DashboardBreadcrumb,
    ValidationObserver,
    TextField,
    DateField,
    AutoComplete,
    CopyExportJobModal
  },
  mounted() {
    this.getAccountDetails();
  },
  data() {
    return {
      transportModes: [
        {
          text: "By Air",
          textIdentifier: "A"
        },
        {
          text: "By Sea",
          textIdentifier: "S"
        }
      ],
      isSbMainFormLoading: false,
      copyExportJobModal: false
    };
  },
  mixins: [commonMethodsMixin, handleExportJobMixin],
  methods: {
    getAccountDetails() {
      if (this.checkIfNewJob) {
        // account details is obtained from gettes, by default it is set to null
        if (this.accountDetails.id === null) {
          this.$store.dispatch(GET_ACCOUNT_DETAILS);
        }
      }
      return;
    },
    copyExportJob() {
      this.copyExportJobModal = true;
      return;
    }
  },
  computed: {
    accountDetails() {
      return this.$store.getters.account;
    },
    checkIfNewJob() {
      return window.location.href.indexOf("/new/") > -1;
    },
    portLocations() {
      return this.$store.getters.homePorts;
    },
    breadCrumbItems() {
      return [
        {
          title: "Dashboard",
          route: "dashboard.home",
          children: [
            {
              title: "Export",
              route: "dashboard.export",
              children: [
                {
                  title: "SB Main",
                  route: "dashboard.export.sbMain"
                }
              ]
            }
          ]
        }
      ];
    },
    jobName: {
      get() {
        return this.$store.state.ExportModuleStore.sbMain.jobName;
      },
      set(value) {
        this.$store.commit(MT.SET_SBMAIN_NAME, { value });
      }
    },
    jobDate: {
      get() {
        return this.$store.state.ExportModuleStore.sbMain.jobDate;
      },
      set(value) {
        this.$store.commit(MT.SET_SBMAIN_DATE, { value });
      }
    },
    portLocationDropdownValue: {
      get() {
        return this.$store.state.ExportModuleStore.sbMain.portLocation;
      },
      set(portLocationObject) {
        this.$store.commit(MT.SET_SBMAIN_PORT_CODE_OF_LOADING_DROPDOWN_VALUE, { value: portLocationObject.text });
        this.portLocation = portLocationObject.textIdentifier;
      }
    },
    portLocation: {
      get() {
        return this.$store.state.ExportModuleStore.sbMain.portLocation;
      },
      set(value) {
        this.$store.commit(MT.SET_SBMAIN_PORT_LOCATION, { value });
        this.$store.commit(MT.SET_SBMAIN_PORT_CODE_OF_LOADING, { value });
      }
    },
    transportModeArray: {
      get() {
        const selectedTransportMode = this.transportMode;
        if (selectedTransportMode !== "" && !!selectedTransportMode) {
          return this.transportModes.find(type => type.textIdentifier.includes(selectedTransportMode));
        } else {
          return this.transportModes[0];
        }
      },
      set(value) {
        value = value.textIdentifier;
        this.$store.commit(MT.SET_SBMAIN_TRANSPORT_MODE, { value });
      }
    },
    transportMode: {
      get() {
        return this.$store.state.ExportModuleStore.sbMain.transportMode;
      },
      set(value) {
        this.$store.commit(MT.SET_SBMAIN_TRANSPORT_MODE, { value });
      }
    },
    icegateId: {
      get() {
        if (this.checkIfNewJob) {
          return this.$store.getters.account.icegate_id;
        }
        return this.$store.state.ExportModuleStore.sbMain.iec;
      },
      set(value) {
        this.$store.commit(MT.SET_SBMAIN_EXPORTER_IEC, { value });
      }
    },
    cha: {
      get() {
        if (this.checkIfNewJob) {
          return this.$store.getters.account.cha_license_number;
        }
        return this.$store.state.ExportModuleStore.sbMain.chaLicenseNo;
      },
      set(value) {
        this.$store.commit(MT.SET_SBMAIN_CHA, { value });
      }
    },
    rbiWaiverNo: {
      get() {
        return this.$store.state.ExportModuleStore.sbMain.rbiWaiverNo;
      },
      set(value) {
        this.$store.commit(MT.SET_SBMAIN_RBI_WAIVER_NO, { value });
      }
    },
    rbiWaiverDate: {
      get() {
        return this.$store.state.ExportModuleStore.sbMain.rbiWaiverDate;
      },
      set(value) {
        this.$store.commit(MT.SET_SBMAIN_RBI_WAIVER_DATE, { value });
      }
    }
  }
};
</script>
